// PIN login (feature/pin-login), client side of the switch.
//
// When on, the sign-in page tells the backend it can show the PIN screens ("capabilities": ["PIN"]).
// The backend still decides: it offers a PIN step only when PIN login is enabled for the deployment
// AND the user's persona is switched to PIN. With this flag off the page never asks, so every login
// is today's OTP login whatever the backend says.
export const isPinLoginEnabled = () =>
  String(process.env.REACT_APP_PIN_LOGIN_ENABLED || '').trim().toLowerCase() === 'true';

export const PIN_LENGTH = 6;
